<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-message-check fa-fw" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <div class="tile-title">{{request.request_type | capitalize}}</div>
            <div class="meta"><i class="far fa-clock mr-2 fa-fw"></i>{{request.created_at | moment('MMMM Do YYYY, h:mm:ss a')}}</div>
            <div class="meta"><i class="far fa-paper-plane mr-2 fa-fw"></i>{{request.type | capitalize}}</div>
            <div class="meta" v-if="request.user_id"><i class="far fa-user mr-2 fa-fw"></i>{{ request.user_name || request.user_id }}<span v-if="request.user_name"> ({{ request.user_id }})</span></div>
            <div class="meta" v-if="request.plan_id"><i class="far fa-money-check-alt mr-2 fa-fw"></i>{{ request.plan_id }}</div>
        </template>
        <template v-slot:status>
            <div class="stats">
                <span class="stat"><i class="fas fa-check" v-if="request.fulfilled_at"></i><i class="fas fa-ban" v-if="!request.fulfilled_at"></i></span>
            </div>
        </template>
        <template v-slot:details>
            <div class="mt-3">
                <div class="data mt-1">
                    <data-row mini title="User ID">{{request.user_id}}</data-row>
                    <data-row mini title="Plan ID">{{request.plan_id}}</data-row>
                    <data-row mini title="Type">{{request.type}}</data-row>
                    <data-row mini title="Method">{{request.request_type}}</data-row>
                    <data-row mini title="Created">{{request.created_at | moment('MMMM Do YYYY, h:mm:ss a')}}</data-row>
                    <data-row mini title="Fulfilled">{{request.fulfilled_at | moment('MMMM Do YYYY, h:mm:ss a')}}</data-row>
                    <data-row mini title="ID">{{request.id}}</data-row>
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";

    export default {
        name: 'AccountRequestTile',
        components: {CardListItem, DataRow},
        props: {
            card: {
                required: true
            },
            request: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }
</style>
